import { render } from "./FileCircleIcon.vue?vue&type=template&id=55a33719"
import script from "./FileCircleIcon.vue?vue&type=script&lang=js"
export * from "./FileCircleIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__